/**
 * Ness Frame Character - Shared 네임스페이스 (Backend/Frontend 공통)
 *
 * 사용법:
 * import { NessLabsFrameS } from '@modules/NessLabs/Frame/S';
 *
 * NessLabsFrameS.NessFrameProduct.isFrameBp(base_product)
 * NessLabsFrameS.calculateRetailPrice(frame_option, character_option)
 */

import { NessFrameProduct, calculateRetailPrice } from './constant';
import { makeOptionInfosForNessFrameBpWithCarts } from './cart-hook';
import { makeOptionInfosForNessFrameBpWithOrderHistory } from './order-history-hook';

export const NessLabsFrameS = {
  NessFrameProduct,
  calculateRetailPrice,
  makeOptionInfosForNessFrameBpWithCarts,
  makeOptionInfosForNessFrameBpWithOrderHistory,
};

// Type exports
export type { FrameCharacter, NessAssocSelectedOptionGroup, NessFrameDetails } from './constant';
